import { Star } from "lucide-react";
import { googleReviewSummary } from "@/data/googleReviews";

export function GoogleHeroBadge({ className = "" }: { className?: string }) {
  const { rating, reviewCount } = googleReviewSummary;

  return (
    <div className={`inline-flex items-center gap-3 rounded-lg border border-white/20 bg-primary/70 px-4 py-3 text-white backdrop-blur-sm ${className}`}>
      <img
        src={`${import.meta.env.BASE_URL}google-g.png`}
        alt="Google"
        width={32}
        height={32}
        className="h-8 w-8 shrink-0"
      />
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2.5">
          <p className="text-xl font-semibold leading-none tabular-nums">
            {String(rating).replace(".", ",")}/5
          </p>
          <span className="inline-flex gap-0.5" aria-hidden="true">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star key={star} className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400" />
            ))}
          </span>
        </div>
        <p className="text-sm leading-snug text-white/85">sur {reviewCount} avis</p>
      </div>
    </div>
  );
}